import request from '@/utils/request'

const userRecycle = {
  name: 'userRecycle',
  state: {
    isUserRecycleDetailLoading: false,
    userRecycleDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_USERRECYCLE_DETAIL_LOADING: (state, data) => {
      state.isUserRecycleDetailLoading = data
    },
    SET_MODULES_USERRECYCLE_DETAIL_DATA: (state, data) => {
      state.userRecycleDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryUserRecycleDetailData({ commit }, id) {
      commit('SET_IS_MODULES_USERRECYCLE_DETAIL_LOADING', true)
      commit('SET_MODULES_USERRECYCLE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/userEmployees/userEmployeesDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_USERRECYCLE_DETAIL_LOADING', false)
          commit('SET_MODULES_USERRECYCLE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_USERRECYCLE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetUserRecycleDetailData({ commit }) {
      commit('SET_MODULES_USERRECYCLE_DETAIL_DATA', {
        isHandleDelivery: 1,
        isHandleOrder: 1,
        isHelpDelivery: 1,
        isHelpOrder: 1,
        isAreaManager: 0
      })
    },
    setUserRecycleDetailData({ commit }, data) {
      commit('SET_MODULES_USERRECYCLE_DETAIL_DATA', data)
    },
    // 加载社区下拉列表
    queryUserAreaManagerListNoPage({ commit }, isAll) {
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/userEmployees/userAreaManagerListNoPage',
          method: 'post'
        }).then(response => {
          for (const item of response.data) {
            item.label = item.name
            item.value = item.id
          }
          if (isAll) {
            response.data.unshift({ label: '全部', value: '' })
          }
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default userRecycle
